import { getMessages } from '../../../../../../../store/constants';

export const CARD_CHECKLIST_COPY_BUTTON_CANCEL = getMessages().getText('card_form_checklist_copy_button_cancel');
export const CARD_CHECKLIST_COPY_BUTTON_OK = getMessages().getText('card_form_checklist_copy_button_ok');
